import React from 'react';
import { bool, node, string, oneOf } from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from 'TMConstants';

const StyledList = styled.ul`
    padding-inline-start: 16px;
    text-align: left;
    width: fit-content;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    p {
        margin-bottom: 0;
        margin-top: 0;
    }
    ${({ markerStyle }) =>
        markerStyle === 'numbered' && 'list-style-type: number;'}
    ${({ listCheckMarks }) =>
        listCheckMarks &&
        `
            padding-inline-start: 0;
            gap:12px;

        `}
    
    @media (max-width: ${breakpoints.mobileTablet}px) {
        ${({ mobileCenterAlignText }) =>
            mobileCenterAlignText &&
            `margin-left: auto; margin-right: auto;`}
    }

    @media (min-width: ${breakpoints.mobileTablet + 1}px) {
        ${({ centerAlignText }) =>
            centerAlignText && `margin-left: auto; margin-right: auto;`}
    }
`;

const List = ({
    markerStyle,
    listCheckMarks,
    centerAlignText,
    mobileCenterAlignText,
    listTickVariant = 'green',
    children
}) => (
    <StyledList
        markerStyle={markerStyle}
        listCheckMarks={listCheckMarks}
        centerAlignText={centerAlignText}
        mobileCenterAlignText={mobileCenterAlignText}>
        {listCheckMarks
            ? React.Children.map(children, (child) => {
                  /* istanbul ignore else */
                  if (React.isValidElement(child)) {
                      return React.cloneElement(child, {
                          listCheckMarks,
                          listTickVariant
                      });
                  }
                  /* istanbul ignore next */
                  return child;
              })
            : children}
    </StyledList>
);

List.propTypes = {
    children: node.isRequired,
    markerStyle: string,
    listCheckMarks: bool,
    centerAlignText: bool,
    mobileCenterAlignText: bool,
    listTickVariant: oneOf(['blue', 'green'])
};
List.defaultProps = {
    markerStyle: 'bulleted',
    listCheckMarks: false,
    centerAlignText: false,
    mobileCenterAlignText: false,
    listTickVariant: 'green'
};
export default List;
